import { useQuery, QueryClient } from '@tanstack/react-query';
import { getLoggedInUser } from '~/monolith-api';
import { ApiClient } from '@dozuki/web-js/utils';

const KEY = 'logged-in-user';

export function useLoggedInUser() {
   return useQuery([KEY], async () => {
      return await getLoggedInUser();
   });
}

export async function prefetchLoggedInUser(
   apiClient: ApiClient,
   queryClient: QueryClient
): Promise<void> {
   await queryClient.fetchQuery([KEY], () => getLoggedInUser({ apiClient }));
}
